import { createSlice } from "@reduxjs/toolkit";
import SonucYazdirmaListeRequest from "src/models/Alis/SonucYazdirmaListeRequest";
import VAlisSonucDTO from "src/models/Alis/VAlisSonucDTO";
import VKulturWsDTO from "src/models/Alis/VKulturWsDTO";
import VSonucDosyaWsDTO from "src/models/Alis/VSonucDosyaWsDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { AlisApi } from "src/services/HastaKayit/AlisApi";
import { helper } from "src/utils/helper";

export class TarihGrup {
  tarih: string = "";
  servisAdi: string = "";
  kultur: boolean = false;
  dosya: boolean = false;
  eImza: boolean = false;
}
class Kultur {
  data: Array<VKulturWsDTO> = [];
  sonuclar: Array<VKulturWsDTO> = [];
  bakteriler: Array<VKulturWsDTO> = [];
  antibiyogramlar: Array<VKulturWsDTO> = [];
}
interface LaboratuvarSonucState {
  searchModel: SonucYazdirmaListeRequest,
  data: Array<VAlisSonucDTO>,
  tarihGrup: Array<TarihGrup>,
  selectTarihGrup: TarihGrup,
  filterData: Array<VAlisSonucDTO>,
  testArama: string,
  tabValue: string,
  kultur: Kultur,
  dosya: Array<VAlisSonucDTO>,
  openViewer: boolean,
  pdfs: Array<VSonucDosyaWsDTO>,
  raporsorguId: number,
  printData: Array<VAlisSonucDTO>,
  printSelectedRows: Array<string>,
  directPrint: boolean,
  searchHandler: boolean,
}
export const SonucIzlemeLabSonucGrupla = (data: Array<VAlisSonucDTO>, testArama: string): TarihGrup => {
  let response: TarihGrup = new TarihGrup();
  if (data.length === 0)
    return response;

  let res = data.map(m => m);
  if (testArama)
    res = res.filter(f => helper.UpperCaseAsc(f.testAdi).indexOf(helper.UpperCaseAsc(testArama)) > -1);
  res.forEach(m => {
    const kultur = data.filter(f => f.kayittarihi === m.kayittarihi && f.kulturTesti === "E" && f.servisPoliklinikAdi === m.servisPoliklinikAdi && f.genetikTesti == "H")
    const dosya = data.filter(f => f.kayittarihi === m.kayittarihi && f.dosyaVar === "E" && f.servisPoliklinikAdi === m.servisPoliklinikAdi)
    const eImza = data.filter(f => f.kayittarihi === m.kayittarihi && f.eimzaliGenetikTestAdi && f.servisPoliklinikAdi === m.servisPoliklinikAdi)
    response = {
      kultur: kultur?.length > 0,
      servisAdi: m.servisPoliklinikAdi,
      tarih: m.kayittarihi,
      dosya: dosya?.length > 0,
      eImza: eImza?.length > 0
    };
  });
  return response;
}
export const LabSonucGrupla = (data: Array<VAlisSonucDTO>, testArama: string): Array<TarihGrup> => {
  if (data.length === 0)
    return []
  let group: Array<TarihGrup> = []
  let res = data.map(m => m);
  if (testArama)
    res = res.filter(f => helper.UpperCaseAsc(f.testAdi).indexOf(helper.UpperCaseAsc(testArama)) > -1);
  res.forEach(m => {
    const kontrol = group.find(f => f?.tarih === m.kayittarihi && f.servisAdi === m.servisPoliklinikAdi);
    const kultur = data.filter(f => f.kayittarihi === m.kayittarihi && f.kulturTesti === "E" && f.servisPoliklinikAdi === m.servisPoliklinikAdi )
    const dosya = data.filter(f => f.kayittarihi === m.kayittarihi && f.dosyaVar === "E" && f.servisPoliklinikAdi === m.servisPoliklinikAdi)
    const eImza = data.filter(f => f.kayittarihi === m.kayittarihi && f.eimzaliGenetikTestAdi && f.servisPoliklinikAdi === m.servisPoliklinikAdi)
    if (!kontrol)
      group.push({
        kultur: kultur?.length > 0,
        servisAdi: m.servisPoliklinikAdi,
        tarih: m.kayittarihi,
        dosya: dosya?.length > 0,
        eImza: eImza?.length > 0
      })
  })
  return group.sort((a, b) => a.tarih > b.tarih ? -1 : 1)
}
export const LabSonucFiltrele = (data: Array<VAlisSonucDTO>, grup: TarihGrup, testArama: string): Array<VAlisSonucDTO> => {
  if (data.length === 0)
    return []
  if (grup === null)
    return []
  let filter = data.filter(f => f.kayittarihi === grup.tarih &&
    f.servisPoliklinikAdi === grup.servisAdi)
  if (testArama)
    filter = filter.filter(f => helper.UpperCaseAsc(f.testAdi).indexOf(helper.UpperCaseAsc(testArama)) > -1);
  return filter;
}
const LaboratuvarSonucSlice = createSlice<LaboratuvarSonucState, MapReducerPayloads<LaboratuvarSonucState, {
  setState: LaboratuvarSonucState,
  setSearchModel: SonucYazdirmaListeRequest,
  setTestArama: string,
  setTabValue: string,
  setSearchHandler: boolean,
}>>({
  name: 'LaboratuvarSonuc',
  initialState: {
    searchModel: {
      kimlikId: 0,
      muracaatId: 0,
      basTarih: helper.datetimeToday(),
      bitTarih: helper.datetimeToday(),
      filterStatu: 3,
      kulturStatu: 1
    },
    data: [],
    tarihGrup: new Array<TarihGrup>(),
    selectTarihGrup: null,
    filterData: [],
    testArama: "",
    tabValue: "0",
    kultur: new Kultur(),
    dosya: [],
    openViewer: false,
    pdfs: [],
    raporsorguId: 0,
    printSelectedRows: [],
    printData: [],
    directPrint: false,
    searchHandler: true,
  },
  reducers: {
    setState: (state, action) => action.payload,
    setSearchModel: (state, action) => {
      state.searchModel = action.payload
    },
    setTestArama: (state, action) => {
      state.testArama = action.payload
    },
    setTabValue: (state, action) => {
      state.tabValue = action.payload
    },
    setSearchHandler: (state, action) => {
      state.searchHandler = action.payload
    },
  }
})
export default LaboratuvarSonucSlice;